import { render, staticRenderFns } from "./tabFour.vue?vue&type=template&id=51711830&scoped=true"
import script from "./tabFour.vue?vue&type=script&lang=js"
export * from "./tabFour.vue?vue&type=script&lang=js"
import style0 from "./tabFour.vue?vue&type=style&index=0&id=51711830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51711830",
  null
  
)

export default component.exports